import { useEffect } from "react";

const SITE_URL = "https://www.fencodigital.co.uk";
const SITE_NAME = "Fenco Digital";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    const tag = selector.includes("property=")
      ? document.createElement("meta")
      : selector.includes("name=")
      ? document.createElement("meta")
      : null;
    if (!tag) return;
    if (selector.includes("property=")) {
      tag.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
    } else {
      tag.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
    }
    document.head.appendChild(tag);
    el = tag;
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Hook to set per-page SEO metadata.
 * @param {object} opts
 * @param {string} opts.title    Page title (will be suffixed with " | Fenco Digital")
 * @param {string} opts.description Meta description
 * @param {string} [opts.path]   Path (default: window.location.pathname)
 */
export default function useSEO({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    const url = `${SITE_URL}${path ?? window.location.pathname}`;
    const image = `${SITE_URL}/brand/fenco-logo.png`;

    setMeta('meta[name="description"]', "content", description);

    // Open Graph
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:site_name"]', "content", SITE_NAME);
    setMeta('meta[property="og:image"]', "content", image);

    // Twitter
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", image);

    // Canonical
    setLink("canonical", url);
  }, [title, description, path]);
}
